const defaultCellProps = (props: any, { cell }: any) => {
    return { ...props };
};

/**
 * Default Plugins.
 * Selecting Days, Weeks, ETC
 *
 * Eventually when we get to Giant Calendar, can add scheduling of events and things?
 *
 * @returns
 */
export function makeDefaultPluginHooks() {
    return {
        stateReducers: [],
        headers: [],
        prepareRow: [],
        getCellProps: [defaultCellProps],
        useInstance: [],
    };
}
